export const GET_LOCATION_TRANSACTIONS = 'GET_LOCATION_TRANSACTIONS';
export const GET_LOCATION_SALES = 'GET_LOCATION_SALES';
export const GET_LOCATION_REFUND = 'GET_LOCATION_REFUND';
export const GET_LOCATION_NEW_USER_TRANSACTIONS =
  'GET_LOCATION_NEW_USER_TRANSACTIONS';
export const LOADING = 'LOADING';
